export { normalizeVideo } from '../Articles/utils/videos';
export var thumbsnails = {
  mq: function mq(video) {
    return "https://i3.ytimg.com/vi_webp/".concat(video.id, "/mqdefault.webp");
  },
  max: function max(video) {
    return "https://img.youtube.com/vi_webp/".concat(video.id, "/maxresdefault.webp");
  }
};